import ApiRequester from "./ApiRequester";

function Logout(dData) {
    try{
        let payload = [{campus_id: dData.acnt, user_id: dData.user, user_log_type_id: 2, modified_by: dData.user}]
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_user_logs", Payload: payload, urlType: "PUT",
                            CampusId: dData.acnt, User: dData.user, ClientId: dData.sessionId}).then(data => {
            sessionStorage.clear();
            return window.location.href = "/";
        });
    }catch (e) {
        sessionStorage.clear();
        return window.location.href = "/";
    }
}

export default Logout;